import { render, staticRenderFns } from "./pr_open.vue?vue&type=template&id=03591d82"
import script from "./pr_open.vue?vue&type=script&lang=js"
export * from "./pr_open.vue?vue&type=script&lang=js"
import style0 from "./pr_open.vue?vue&type=style&index=0&id=03591d82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports